import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

const getHTTPClient = (config: AxiosRequestConfig = {}): AxiosInstance => {
  config.baseURL = config.baseURL || process.env.REACT_APP_API_URL;
  return axios.create(config);
};

export default getHTTPClient;
